import { Wrapper } from '../../components/wrapper.component';
import { OnInit, ViewChild, ChangeDetectorRef, Component } from '@angular/core';
import { filterPageTypes, toggleFilterTypes } from 'src/app/store/filters.era';
import { loadLocal } from 'src/app/helpers/helpers';
import { saveTable } from '../performers/performerSharedFunctions';
import { BudgetTableData, budgetColumns } from 'src/app/helpers/table-column-types';
import { TableColumn, TableMenuItem } from 'src/app/helpers/table.data';
import { allDefaultBudgetColumns, budgetColumnsById } from 'src/app/helpers/table-helpers';
import { NestedTableComponent } from './../../components/nested-table/nested-table.component'
import { budgetsTableReselector } from '../../store/reselectors/budget.reselector';
import { JoiAccount } from 'globals/store/accounts.data';
import { selectedBudgetAccountReselector } from '../../store/reselectors/accounts.reselector';
import { permissionsActions } from 'src/app/store/permissions.era';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule, DatePipe } from '@angular/common';

@Component({
    selector: 'budgets-table',
    templateUrl: './budgets-table.html',
    standalone: true,
    providers: [DatePipe],
    imports: [CommandMenuComponent, MatCheckboxModule, NestedTableComponent, CommonModule],
})
export class BudgetsTableComponent extends Wrapper<BudgetsTableComponent> implements OnInit {
  filterPage = filterPageTypes.budgets
  budgetColumns = budgetColumns
  columnData: TableColumn[] = allDefaultBudgetColumns
  columnsById: { [id: string]: TableColumn } = budgetColumnsById
  tableData: BudgetTableData[] = []
  tableRowsById: { [id:string]: BudgetTableData } = {}
  selectedIds: string[] 
  busy = false
  menuItems: TableMenuItem[] = []
  condensed: boolean
  account: JoiAccount
  showClosed = false
  @ViewChild(NestedTableComponent) nestedTable: NestedTableComponent<BudgetTableData>

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.uiService.changePageTitle("Budgets", true)
    this.selectCallback<{ tableData: BudgetTableData[], tableRowsById: {[key: string]: BudgetTableData}}, any>(budgetsTableReselector, null, data => {
      if (!data) {
        this.tableData = [] // for when the last is deleted
        return
      }
      console.log(data)
      const { tableData, tableRowsById } = data
      this.tableData = tableData
      this.tableRowsById = tableRowsById
    })
    this.loadCondensed()
    this.selectProp(selectedBudgetAccountReselector, null, 'account')
    this.subCallback(this.store.select('filters', 'toggleFilters', this.filterPage, 'condensed'), _ => this.loadCondensed())
    this.subProp(this.store.select('settings','user','showClosedBudgets'), 'showClosed')
  }

  ngOnInit() {
  }

  toggleShowClosedBudgets(event) {
    this.settingsService.saveUserSetting('showClosedBudgets', event.checked);
  }


  saveTable() {
    saveTable('budgets', `${this.account.title} quotes table`, this.dialog, this.nestedTable)
  }

  selectIds(ids: Set<string>) {
    this.selectedIds = Array.from(ids)
  }

  loadCondensed() {
    this.condensed = loadLocal(`${this.filterPage}:${toggleFilterTypes.condensed}`, false)
  }

  openBudget(row: BudgetTableData) {
    console.log("OPEN BUDGET:", row)
    this.store.dispatch(permissionsActions.setPageType('budget'))
    this.router.navigate([`event/revenue/${row.id}`])
  }

}
